import { Reveal, SectionHead } from "./shared";
import { PresenceMap } from "./PresenceMap";

const PRESENCE_STATES = ["Maharashtra", "Telangana", "Karnataka", "Andhra Pradesh"];

export const Presence = () => (
    <section data-testid="presence-section" className="relative bg-white py-16 lg:py-32">
        <div className="vec-container">
            <div className="grid grid-cols-12 gap-y-10 lg:gap-x-14 items-center">
                <div className="col-span-12 lg:col-span-5">
                    <SectionHead
                        index="SEC 08"
                        eyebrow="Our Presence"
                        title="Our Presence"
                        sub="Key areas of project presence across Maharashtra, Karnataka and Andhra Pradesh."
                    />
                    <Reveal delay={0.2}>
                        <ul className="mt-8 max-w-md border-t border-vec-border">
                            {PRESENCE_STATES.map((s, i) => (
                                <li
                                    key={s}
                                    data-testid={`presence-legend-${i}`}
                                    className="group flex items-center gap-4 border-b border-vec-border py-3.5"
                                >
                                    <span className="font-mono-tech text-[10px] text-vec-charcoal/40">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                    <span className="h-2.5 w-2.5 rotate-45 bg-vec-green/70 transition-colors duration-300 group-hover:bg-vec-green-bright" aria-hidden="true" />
                                    <span className="font-display text-base sm:text-lg font-medium uppercase tracking-wide text-vec-charcoal group-hover:text-vec-green transition-colors duration-300">
                                        {s}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <p className="mt-6 max-w-md font-mono-tech text-[10px] uppercase tracking-[0.2em] leading-relaxed text-vec-charcoal/45">
                            Areas of project presence — not office locations
                        </p>
                    </Reveal>
                </div>

                <div className="col-span-12 lg:col-span-7">
                    <Reveal delay={0.15}>
                        <div
                            data-testid="presence-map"
                            className="tech-frame relative border border-vec-border bg-white overflow-hidden lg:max-w-[940px] lg:mx-auto"
                        >
                            <div className="absolute inset-0 tech-grid opacity-50" aria-hidden="true" />
                            <span className="absolute top-3 left-3 z-10 bg-white/85 px-2 py-1 font-mono-tech text-[9px] uppercase tracking-[0.22em] text-vec-charcoal/40">
                                Regional Presence Map
                            </span>
                            <span className="absolute top-3 right-3 z-10 bg-white/85 px-2 py-1 font-mono-tech text-[9px] uppercase tracking-[0.22em] text-vec-charcoal/40">
                                MH / TS / KA / AP
                            </span>
                            <div className="relative px-2 py-4 sm:px-6 sm:py-6 lg:px-8">
                                <PresenceMap />
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
